import { render, staticRenderFns } from "./WelcomeCell.vue?vue&type=template&id=1655f048&"
import script from "./WelcomeCell.vue?vue&type=script&lang=js&"
export * from "./WelcomeCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports